export default __webpack_public_path__ + "static/media/bg.bd8376ee.svg";